export const validatorPossui2Dependentes65anos = (dependentes,valoresForm,idadeAssociado) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        calcularQuantidadeDependentes65anos(dependentes,idadeAssociado  )
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const calcularQuantidadeDependentes65anos = ((dependentes,idadeAssociado) => {
    let qtdDependentes =  dependentes.filter(dep => dep.Idade >= 65).length;
    
    if (idadeAssociado >= 65){
        qtdDependentes = qtdDependentes + 1;
    }

    return qtdDependentes === 2 ? true : false;
});
const idadeAte65 = idade => idade >= 65;